import Collection from './collection.js';
import LeaveApproval from 'newModels/leave-approval.js';

export default class LeaveApprovals extends Collection {
    url() {
        if (this.requester) {
            return this.requester.url() + '/leaveApprovers';
        }

        if (this.approver) {
            return this.approver.url() + '/leaveRequesters';
        }

        return '/LeaveApprovals';
    }

    initialize(models, {requester = null, approver = null} = {}) {
        this.model = LeaveApproval;
        super.initialize(...arguments);
        this.requester = requester;
        this.approver = approver;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/leave-approvals.js